export default __webpack_public_path__ + "static/springandsummer (5)-ba74de3dfba593dc191986cf1178f5e9.jpeg";